import { AppProps } from '../../@types/AppProps';
import { Condition } from '../../@types/Condition';
import { Valuation } from '../../@types/Valuation';
import HtmlNode from '../../Components/Extension/HtmlNode';
import Contact from './Contact';
import MileageAndCondition from './MileageAndCondition';
import RegistrationNumber from './RegistrationNumber';
import ValuationResult from './ValuationResult';
import AboutValuation from './AboutValuation';
import VehicleDetails from './VehicleDetails';
import FactorsAffectingPrice from './FactorsAffectingPrice';
import { Vehicle } from '../../@types/Vehicle';

const COMPONENT_REGISTRATION_NUMBER = 'component-registration-number';
const COMPONENT_VEHICLE_DETAILS = 'component-vehicle-details';
const COMPONENT_MILEAGE_AND_CONDITION = 'component-mileage-and-condition';
const COMPONENT_VALUATION = 'component-valuation';
const COMPONENT_CONTACT = 'component-contact';

export interface MainState {
  registrationNumber: string;
  mileage: string;
  condition?: Condition;
  fname: string;
  lname: string;
  email: string;
  phone: string;
  branchId: string;
  description: string;
}

interface MainProps {
  state: MainState;
  vehicle: Vehicle;
  settings: AppProps;
  onProceed: (state: MainState, vehicle: Vehicle) => void;
  onEdit: (state: MainState) => void;
}

class Main extends HtmlNode {
  private readonly props: MainProps;
  private state: MainState;
  private vehicle?: Vehicle;
  private valuation?: Valuation;
  private contexts: {
    componentRegistrationNumber?: RegistrationNumber;
  } = {};

  constructor(element: HTMLElement, props: MainProps) {
    super(element);
    this.props = props;
    this.state = props.state;
    this.vehicle = props.vehicle;

    this.render();
  }

  private onEdit() {
    this.props.onEdit(this.state);
  }

  onProceed(nextState: MainState) {
    if (this.vehicle) {
      this.props.onProceed(
        {
          ...nextState,
        },
        this.vehicle
      );
    }
  }

  private onEditMilageAndCondition() {
    this.valuation = undefined;
    this.render();
  }

  updateRegistrationNumber(registrationNumber: string, vehicle?: Vehicle) {
    this.vehicle = vehicle;
    this.state.registrationNumber = registrationNumber;
    this.render();
  }
  updateMileageAndCondition(mileage: string, condition: Condition, valuation: Valuation) {
    this.valuation = valuation;
    this.state.mileage = mileage;
    this.state.condition = condition;
    this.render();
  }

  updateContactSilent(nextState: MainState) {
    this.state = {
      ...nextState,
    };
  }

  render() {
    this.node.innerHTML = `
      ${AboutValuation}
      <section class="waykevaluation-page-section" aria-label="Biluppgifter">
        <div class="waykevaluation-shadow-box">
          <div class="waykevaluation-stack waykevaluation-stack--4" id="${COMPONENT_REGISTRATION_NUMBER}"></div>
          ${
            this.vehicle
              ? `<div class="waykevaluation-stack waykevaluation-stack--4" id="${COMPONENT_VEHICLE_DETAILS}"></div>`
              : ''
          }
        </div>
      </section>
      ${
        this.vehicle && !this.valuation
          ? `
            <section class="waykevaluation-page-section waykevaluation-page-section--alt" aria-label="Bilens miltal och skick">
              <div id="${COMPONENT_MILEAGE_AND_CONDITION}"></div>
            </section>
          `
          : ''
      }
      ${
        this.valuation
          ? `
            <section class="waykevaluation-page-section" aria-label="Värdering" id="${COMPONENT_VALUATION}"></section>
            ${FactorsAffectingPrice}
            <div class="waykevaluation-page-section" aria-hidden="true">
              <hr class="waykevaluation-separator waykevaluation-separator--strong" />
            </div>
            <section class="waykevaluation-page-section" aria-label="Intresseanmälan försäljning av bil" id="${COMPONENT_CONTACT}"></section>
          `
          : ''
      }
    `;

    this.contexts.componentRegistrationNumber = new RegistrationNumber(
      document.querySelector<HTMLDivElement>(`#${COMPONENT_REGISTRATION_NUMBER}`),
      {
        settings: this.props.settings,
        vehicle: this.vehicle,
        state: this.state,
        onUpdate: (registrationNumber: string, vehicle?: Vehicle) =>
          this.updateRegistrationNumber(registrationNumber, vehicle),
        onEdit: () => this.onEdit(),
      }
    );

    if (this.vehicle) {
      new VehicleDetails(document.querySelector<HTMLDivElement>(`#${COMPONENT_VEHICLE_DETAILS}`), {
        vehicle: this.vehicle,
        mileage: this.valuation ? this.state.mileage : undefined,
        condition: this.valuation ? this.state.condition : undefined,
        onEditMilageAndCondition: () => this.onEditMilageAndCondition(),
      });
    }

    if (this.vehicle && !this.valuation) {
      new MileageAndCondition(
        document.querySelector<HTMLDivElement>(`#${COMPONENT_MILEAGE_AND_CONDITION}`),
        {
          settings: this.props.settings,
          state: this.state,
          onUpdate: (mileage: string, condition: Condition, valuation: Valuation) =>
            this.updateMileageAndCondition(mileage, condition, valuation),
        }
      );
    }

    if (this.valuation && this.state.condition) {
      new ValuationResult(document.querySelector<HTMLDivElement>(`#${COMPONENT_VALUATION}`), {
        settings: this.props.settings,
        condition: this.state.condition,
        valuation: this.valuation,
      });
      new Contact(document.querySelector<HTMLDivElement>(`#${COMPONENT_CONTACT}`), {
        settings: this.props.settings,
        valuation: this.valuation,
        state: this.state,
        updateContactSilent: (state: MainState) => this.updateContactSilent(state),
        onProceed: (state: MainState) => this.onProceed(state),
      });
    }
  }
}

export default Main;
